import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
    sale: {
        date: new Date(),
        createdBy: '',
        userId: '',
        discount: 0,
        products: [],
        paymentModeId: "",
        paymentNote: "",
        amountPaid: 0,
        // invoiceNumber:""
    },
    saleList: [],
    defaultPaymentModeId: '',
    saleTransactions: [],
    saleTransaction: {
        amount: 0,
        date: new Date(),
        paymentModeId: ''
    },
    receiptData : {}
};

const sale = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

export default sale;